export const useLoginBlockService = () => {
    const getTranslations = (): LoginBlockTranslations | null => {
        const translationsElement = document.getElementById('login-block-translations');

        if (translationsElement?.textContent) {
            return JSON.parse(translationsElement.textContent) as LoginBlockTranslations;
        }

        return null;
    };

    return {
        getTranslations,
    };
};